import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { FROZEN_DEAL_PARAM } from '../../hooks/useFrozenDealToast';
import { getError, getFreezeSelectedContext } from '../../modules/selector';
import { getSearchUrl } from '../../utils/url';
import { RemainingBooking } from './RemainingBooking';
const FixedContainer = /*#__PURE__*/styled('div')({
  name: "FixedContainer",
  class: "f6xizj0",
  propsAsIs: false
});
const StickyContainer = /*#__PURE__*/styled('div')({
  name: "StickyContainer",
  class: "sskvgz0",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => ContentWrapper;
const CtaWrapper = /*#__PURE__*/styled(_exp3())({
  name: "CtaWrapper",
  class: "ckmketp",
  propsAsIs: true
});
interface Props {
  remainingDeals?: number;
}
export const CtaButton: React.FC<Props> = ({
  remainingDeals
}) => {
  const {
    isMobile
  } = useDeviceLayout();
  const {
    hotel,
    searchDetail
  } = useSelector(getFreezeSelectedContext);
  const {
    brandSiteAddress
  } = useBrand();
  const {
    errored
  } = useSelector(getError);
  const Wrapper = isMobile ? StickyContainer : FixedContainer;
  const handleBackToSearch = () => {
    const searchUrl = getSearchUrl(brandSiteAddress, hotel?.objectID as string, searchDetail.checkIn, searchDetail.checkOut, searchDetail.roomsSplit);
    location.assign(`${searchUrl}&${FROZEN_DEAL_PARAM}=1`);
  };
  if (errored) return null;
  return <Wrapper>
      <CtaWrapper paddingX={isMobile ? 's500' : 's700'} paddingBottom="s700" paddingTop="s500">
        <RemainingBooking remainingDeals={remainingDeals} />
        <Button variant="primary" fullWidth size="xl" onClick={handleBackToSearch}>
          <FormattedMessageWrapper id="backToSearch" defaultMessage="Back to search" />
        </Button>
      </CtaWrapper>
    </Wrapper>;
};

require("./CtaButton.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CtaButton.tsx");